import i18next from "i18next";
import * as Util from "../auth/Util";
import * as Setting from "../Setting";

export function rsoFakeAdd() {
  const mockResponse = {
    status: "ok",
    msg: "",
    sub: "",
    name: "",
    data: "Affected",
    data2: null,
  };

  return Promise.resolve(mockResponse);
}

// ::: RSO_CHANGE ::: CAS-254 ::: Fast Login
export function sendFastLoginCode(captchaType, captchaToken, clientSecret, method, countryCode = "IR", dest, type, applicationId, checkUser = "") {
  const formData = new FormData();
  formData.append("captchaType", captchaType);
  formData.append("captchaToken", captchaToken);
  formData.append("clientSecret", clientSecret);
  formData.append("method", method);
  formData.append("countryCode", countryCode);
  formData.append("dest", dest);
  formData.append("type", type);
  formData.append("applicationId", applicationId);
  formData.append("checkUser", checkUser);
  return fetch(`${Setting.ServerUrl}/api/send-fast-login-code`, {
    method: "POST",
    credentials: "include",
    body: formData,
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json()).then(res => {
    if (res.status === "ok") {
      Setting.showMessage("success", i18next.t("user:Verification code sent"));
      return true;
    } else {
      Setting.showMessage("error", res.msg);
      return false;
    }
  });
}
export function rsoFastLogin(organization, phone, application, code, captchaToken = "", countryCode = "IR", redirectUrl, location) {
  const payload = {
    organization: organization || "built-in",
    phone: phone.trim(),
    application: application.trim(),
    code: code.trim(),
    captchaToken: captchaToken || "",
    countryCode: countryCode || "IR",
  };
  const protocol = getProtocolType(location, application);
  let apiUrl = `${Setting.ServerUrl}/api/rso-fast-login?protocol=${protocol}`;
  console.log(protocol);
  if (redirectUrl) {
    apiUrl += `&redirect_uri=${encodeURIComponent(redirectUrl)}`;
  }
  return fetch(apiUrl, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": Setting.getAcceptLanguage(),
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status === "success") {
        Setting.showMessage("success", i18next.t("general:Successful Login"));
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          window.location.href = "/";
        }
        return true;
      } else if (res.data?.status === "user_not_found") {
        const fastLoginToken = res.data?.fastLoginToken;
        const backendRedirect = res.data?.redirectUri || redirectUrl;

        if (!fastLoginToken) {
          Setting.showMessage("error", i18next.t("general:Redirect URL or token is missing"));
          return false;
        }

        if (protocol === "cas") {
          const searchParams = new URLSearchParams(location.search);
          const service = searchParams.get("service") || backendRedirect;
          if (service) {
            const url = new URL(service, window.location.origin);
            url.searchParams.set("ticket", fastLoginToken);
            window.location.href = url.toString();
            return true;
          }
        }

        if (protocol === "saml") {
          if (backendRedirect) {
            const url = new URL(backendRedirect, window.location.origin);
            url.searchParams.set("fastLoginToken", fastLoginToken);
            window.location.href = url.toString();
            return true;
          }
        }

        if (backendRedirect) {
          const url = new URL(backendRedirect, window.location.origin);
          url.searchParams.set("fastLoginToken", fastLoginToken);
          window.location.href = url.toString();
          return true;
        }

        window.location.href = `/login?fastLoginToken=${encodeURIComponent(fastLoginToken)}`;
        return true;
      } else {
        const errorMsg = res.message || res.error || res.data?.message || i18next.t("general:Failed to login");
        Setting.showMessage("error", errorMsg);
        return false;
      }
    })
    .catch((err) => {
      Setting.showMessage("error", i18next.t("general:Network error") + ": " + err.message);
      return false;
    });
}

function getProtocolType(location = window.location, application) {
  const searchParams = new URLSearchParams(location.search);

  if (location.pathname.includes("/cas/") || searchParams.has("service")) {
    return "cas";
  }

  const oAuthParams = Util.getOAuthGetParameters();
  if (oAuthParams?.responseType) {
    return oAuthParams.responseType;
  }

  if (searchParams.has("SAMLRequest")) {
    return "saml";
  }

  return "login";
}

export function RsoGetFile(filename, category) {
  const url = new URL(`${Setting.ServerUrl}/api/get-file`);
  url.searchParams.append("filename", filename);
  url.searchParams.append("category", category);

  return fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  })
    .then(async(response) => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.blob();
    })
    .catch((error) => {
      console.error("Failed to fetch file:", error);
      Setting.showMessage("error", i18next.t("general:Failed to load file"));
      return null;
    });
}
export function rsoSmartFastLogin(
  oauthParams,
  organization,
  phone,
  application,
  code,
  captchaToken = "",
  countryCode = "IR",
  redirectUrl = "",
  serviceUrl = "",
  location = window.location
) {
  const payload = {
    organization: organization || "built-in",
    phone: phone.trim(),
    application: application.trim(),
    code: code.trim(),
    captchaToken: captchaToken || "",
    countryCode: countryCode || "IR",
  };

  const url = new URL(`${Setting.ServerUrl}/api/rso-smart-fast-login`);
  if (oauthParams?.clientId || oauthParams?.client_id) {
    url.searchParams.append("client_id", oauthParams.clientId || oauthParams.client_id);
  }
  if (redirectUrl) {
    url.searchParams.append("redirect_uri", redirectUrl);
  }
  if (oauthParams?.responseType || oauthParams?.response_type) {
    url.searchParams.append("response_type", oauthParams.responseType || oauthParams.response_type);
  }
  if (oauthParams?.state) {
    url.searchParams.append("state", oauthParams.state);
  }
  if (oauthParams?.scope) {
    url.searchParams.append("scope", oauthParams.scope);
  }
  const apiUrl = url.toString();

  oauthParams = {
    ...oauthParams,
    SigninMethode: "Verification code",
    verificationType: "sms",
  };

  return fetch(apiUrl, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": Setting.getAcceptLanguage(),
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status === "ok") {
        Setting.showMessage("success", i18next.t("general:Successful Login"));
        if (redirectUrl) {
          const protocolType = getProtocolType(location, application);
          switch (protocolType) {
          case "cas":
            const st = res.data;
            if (!st) {
              console.error("CAS ticket is missing", res);
              Setting.showMessage("error", i18next.t("general:CAS ticket not received"));
              return;
            }

            const currentSearchParams = new URLSearchParams(location.search);
            let service = currentSearchParams.get("service");

            if (!service && serviceUrl) {
              service = serviceUrl;
            }

            if (!service && res.data2) {
              service = res.data2;
            }

            if (!service) {
              console.error("CAS service URL is missing");
              Setting.showMessage("error", i18next.t("general:CAS service URL not found"));
              return;
            }

            try {
              const serviceUrlObj = new URL(service);
              serviceUrlObj.searchParams.set("ticket", st);
              console.log("CAS redirect to service:", serviceUrlObj.toString());
              window.location.href = serviceUrlObj.toString();
            } catch (e) {
              console.error("Invalid CAS service URL:", service, e);
              Setting.showMessage("error", i18next.t("general:Invalid CAS service URL"));
            }
            return;

          case "code":
            const authCode = typeof res.data === "string" ? res.data : "";
            if (!authCode) {
              console.error("OAuth code is missing or invalid", res);
              Setting.showMessage("error", i18next.t("general:Authorization code not received"));
              return;
            }

            // ✅ پشتیبانی از هر دو نام‌گذاری (snake_case و camelCase)
            const redirectUri = oauthParams.redirect_uri || oauthParams.redirectUri || redirectUrl;
            const clientId = oauthParams.client_id || oauthParams.clientId;
            const state = oauthParams.state;

            if (!redirectUri || !clientId) {
              console.error("Missing OAuth parameters", oauthParams);
              Setting.showMessage("error", i18next.t("general:OAuth configuration is incomplete"));
              return;
            }

            const redirectUrlObj = new URL(redirectUri);
            redirectUrlObj.searchParams.set("client_id", clientId);
            redirectUrlObj.searchParams.set("code", authCode);
            if (state) {
              redirectUrlObj.searchParams.set("state", state);
            }

            console.log("Redirecting with OAuth code:", redirectUrlObj.toString());
            window.location.href = redirectUrlObj.toString();
            return;
          }
          window.location.href = redirectUrl;
        } else {
          window.location.href = "/";
        }
        return true;
      } else {
        const errorMsg = res.msg || i18next.t("general:Login failed");
        Setting.showMessage("error", errorMsg);
        return false;
      }
    })
    .catch((err) => {
      Setting.showMessage("error", i18next.t("general:Network error") + ": " + err.message);
      return false;
    });
}

// ::: RSO_CHANGE ::: CAS-338 ::: Refactor Smart Login Flow Setting
export async function getRequireDataOfStep(stepName) {
  try {
    const url = new URL(`${Setting.ServerUrl}/api/get-require-data-of-step`);
    url.searchParams.append("name", stepName);

    const response = await fetch(url.toString(), {
      method: "GET",
      credentials: "include",
      headers: {
        "Accept-Language": Setting.getAcceptLanguage(),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed (${response.status}): ${errorText}`);
    }

    const data = await response.json();

    if (!data || (!data.is_composite && !data.data_required)) {
      console.warn("Unexpected response format:", data);
    }

    return data;
  } catch (error) {
    console.error("Error fetching required data of step:", error);
    return {
      error: true,
      message: error.message || "Failed to fetch required data.",
    };
  }
}

export async function getStepDetails(stepName) {
  try {
    const url = new URL(`${Setting.ServerUrl}/api/get-step-details`);
    url.searchParams.append("name", stepName);

    const response = await fetch(url.toString(), {
      method: "GET",
      credentials: "include",
      headers: {
        "Accept-Language": Setting.getAcceptLanguage(),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed (${response.status}): ${errorText}`);
    }

    const data = await response.json();

    if (!data || (!data.is_composite && !data.data_required)) {
      console.warn("Unexpected response format:", data);
    }

    return data;
  } catch (error) {
    console.error("Error fetching required data of step:", error);
    return {
      error: true,
      message: error.message || "Failed to fetch required data.",
    };
  }
}

export function getRsoSecureDevice(userId) {
  return fetch(`${Setting.ServerUrl}/api/get-user-devices-of-user?userId=${userId} `, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json());
}

export function deleteRsoSecureDevice(sessionId) {
  return fetch(`${Setting.ServerUrl}/api/delete-user-device?identifierType=session_id&identifiers=${sessionId}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({}),
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json());
}

export function unTrustRsoSecureDevice(id) {
  return fetch(`${Setting.ServerUrl}/api/untrust-user-device-by-id?id=${id}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({}),
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json());
}
export function trustRsoSecureDevice(id) {
  return fetch(`${Setting.ServerUrl}/api/trust-user-device-by-id?id=${id}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({}),
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => res.json());
}
